import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";
const state = {
  standardBreakdown: {
    isBusy: false,
    data: null,
    error: null
  },
  fullStandardBreakdown: {
    isBusy: false,
    data: null,
    error: null
  }
};
const mutations = {
  LOAD_STANDARD_BREAKDOWN_BUSY: (state, payload) => {
    state.standardBreakdown.isBusy = payload;
  },
  LOAD_STANDARD_BREAKDOWN_SUCCESS: (state, payload) => {
    state.standardBreakdown.isBusy = false;
    state.standardBreakdown.data = payload.data;
    state.standardBreakdown.error = null;
  },
  LOAD_STANDARD_BREAKDOWN_FAIL: (state, payload) => {
    state.standardBreakdown.isBusy = false;
    state.standardBreakdown.data = null;
    state.standardBreakdown.error = payload;
  },
  LOAD_FULL_STANDARD_BREAKDOWN_BUSY: (state, payload) => {
    state.fullStandardBreakdown.isBusy = payload;
  },
  LOAD_FULL_STANDARD_BREAKDOWN_SUCCESS: (state, payload) => {
    state.fullStandardBreakdown.isBusy = false;
    state.fullStandardBreakdown.data = payload.data;
    state.fullStandardBreakdown.error = null;
  },
  LOAD_FULL_STANDARD_BREAKDOWN_FAIL: (state, payload) => {
    state.fullStandardBreakdown.isBusy = false;
    state.fullStandardBreakdown.data = null;
    state.fullStandardBreakdown.error = payload;
  },
  DELETE_STANDARD_BREAKDOWN_SUB_OPTIONS_SUCCESS: (state, breakdownId) => {
    const subOptions = state.standardBreakdown.data.sub_options;
    
    state.standardBreakdown.data.sub_options = subOptions.filter(item => {
      return item.id !== breakdownId;
    });
    
    state.standardBreakdown.isBusy = false;
    state.standardBreakdown.error = null;
  },
  DELETE_STANDARD_BREAKDOWN_SUB_OPTIONS_FAIL: (state, payload) => {
    state.standardBreakdown.isBusy = false;
    state.standardBreakdown.data = null;
    state.standardBreakdown.error = payload;
  }
};
const actions = {
  getStandardBreakdown: ({ commit, rootState }, { projectId, queryId, breakdownId, pagination }) => {
    return new Promise((resolve, reject) => {
    commit('LOAD_STANDARD_BREAKDOWN_BUSY', true);
    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };
    //in this case in pagination we will only have:limit, order and sort
    let query = '';
    if(pagination || queryId) {
      query = '?';
      query += queryId ? `query_id=${queryId}${Object.keys(pagination).length > 0 ? '&' : ''}` : '';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }
    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/standard_breakdown/${breakdownId}${query}`, config)
      .then(response => {
        commit('LOAD_STANDARD_BREAKDOWN_SUCCESS', response.data);
        resolve(response.data);
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        console.error(error);
        commit('LOAD_STANDARD_BREAKDOWN_FAIL', error)
        reject()
      });
    })
  },
  getFullStandardBreakdown: ({ commit, rootState }, { projectId, queryId, breakdownId, pagination }) => {
    commit('LOAD_FULL_STANDARD_BREAKDOWN_BUSY', true);
    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };
    //in this case in pagination we will only have:limit, order and sort
    let query = '';
    if(pagination || queryId) {
      query = '?';
      query += queryId ? `query_id=${queryId}${Object.keys(pagination).length > 0 ? '&' : ''}` : '';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }
    return Axios
      .get(`${API_HOST}/projects/${projectId}/queries/standard_breakdown/${breakdownId}${query}`, config)
      .then(response => {
        commit('LOAD_FULL_STANDARD_BREAKDOWN_SUCCESS', response.data);
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        console.error(error);
        commit('LOAD_FULL_STANDARD_BREAKDOWN_FAIL', error)
      });
  },
  addStandardBreakdownEntry: ({ commit, rootState }, { projectId, queryId, breakdownId, entry }) => {
    commit('LOAD_STANDARD_BREAKDOWN_BUSY', true);
    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };
    Axios
      .post(`${API_HOST}/projects/${projectId}/queries/standard_breakdown/${queryId}/${breakdownId}`, entry, config)
      .then(response => {
        commit('LOAD_STANDARD_BREAKDOWN_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        console.error(error);
        commit('LOAD_STANDARD_BREAKDOWN_FAIL', error)
      });
  },
  editStandardBreakdownEntry: ({ commit, rootState }, { projectId, queryId, breakdownId, entry }) => {
    commit('LOAD_STANDARD_BREAKDOWN_BUSY', true);
    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };
    Axios
      .put(`${API_HOST}/projects/${projectId}/queries/standard_breakdown/${queryId}/${breakdownId}/${entry.id}`, entry, config)
      .then(response => {
        commit('LOAD_STANDARD_BREAKDOWN_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        console.error(error);
        commit('LOAD_STANDARD_BREAKDOWN_FAIL', error)
      });
  },
  saveStandardBreakdownSettings: ({ commit, rootState }, { projectId, queryId, breakdownId, entryId, settingsModel }) => {
    commit('LOAD_STANDARD_BREAKDOWN_BUSY', true);
    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };
    Axios
      .put(`${API_HOST}/projects/${projectId}/queries/standard_breakdown/${queryId}/${breakdownId}${entryId ? '/' + entryId : ''}/settings`, settingsModel, config)
      .then(response => {
        commit('LOAD_STANDARD_BREAKDOWN_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        console.error(error);
        commit('LOAD_STANDARD_BREAKDOWN_FAIL', error)
      });
  },
  deleteStandardBreakdownSubOptions: ({ commit, rootState }, { projectId, queryId, breakdownId, entry }) => {
    if (!queryId) return;
    commit('LOAD_STANDARD_BREAKDOWN_BUSY', true);
    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };
    Axios
      .delete(`${API_HOST}/projects/${projectId}/queries/standard_breakdown/${queryId}/${breakdownId}/${entry.id}`, config)
      .then(() => {
        commit('DELETE_STANDARD_BREAKDOWN_SUB_OPTIONS_SUCCESS', entry.id)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});
        commit('DELETE_STANDARD_BREAKDOWN_SUB_OPTIONS_FAIL', error)
      });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};